import { useEditorContext } from 'src/contexts/editorContext';
import { isCustom } from 'src/utils/docType.util';

export const useCanAutomateLinear = () => {
  return useEditorContext(
    ctx => isCustom(ctx.doc?.doctype) && !ctx.doc?.automationId,
  );
};
